import {BaseModel} from "../../../infrastructure/models/base-model";
import {AnalyticsUserDataEventModel} from "../analytics-user-data-event-model";

export class KinesisUserDataEventModel extends BaseModel {

  visitor_id: String;
  browser_type: String;
  browser_version: String;
  device_platform_type: String;
  device_brand: String;
  device_model: String;
  site_version: String;
  lang_id: String;
  competitors: Array;
  competitions: Array;
  total_teams: Number;
  total_leagues: Number;
  os_lang: String;
  os_type: String;
  os_version: String;
  country_id: String;
  show_wizard_ab_test: Boolean;
  website_notifications: String;
  app_device_id: String;

  constructor(eventData: AnalyticsUserDataEventModel, partitionKey: String) {
    super();

    this.visitor_id = partitionKey;
    this.browser_type = eventData.browser_type;
    this.browser_version = eventData.browser_version;
    this.device_platform_type = eventData.device_platform_type;
    this.device_brand = eventData.device_brand;
    this.device_model = eventData.device_model;
    this.site_version = eventData.site_version;
    this.lang_id = eventData.lang_id;
    this.competitors = eventData.competitors;
    this.competitions = eventData.competitions;
    this.datekey = eventData.datekey;
    this.total_teams = eventData.total_teams;
    this.total_leagues = eventData.total_leagues;
    this.os_lang = eventData.os_lang;
    this.os_type = eventData.os_type;
    this.os_version = eventData.os_version;
    this.country_id = eventData.country_id;
    this.timezone = eventData.timezone;
    this.show_wizard_ab_test = eventData.show_wizard_ab_test;
    this.website_notifications = eventData.website_notifications;
    this.app_device_id = eventData.app_device_id;
  }

}
